// @flow
import * as React from 'react';

type Props = {
  assignedBy: string
  assignedTo: string
  avid?: string;
  description: string
  endState: string
  reasonLabel: string
  rootCause: string
  enabledInputs: string[]
};
export const FormView = (props: Props) => {
  return (
    <div className="form-view">
      <div className="d-flex">
        <p className="label">Assignee:</p><p className="data">{props.assignedTo}</p>
      </div>
      <div className="d-flex">
        <p className="label">Reason:</p><p className="data">
        {props.reasonLabel}
      </p>
      </div>
      <div className="d-flex">
        <p className="label">Reason Detail:</p><p className="data">{props.description}</p>
      </div>
      <div className="d-flex">
        <p className="label">Assigned by:</p><p className="data">{props.assignedBy}</p>
      </div>
      {props.enabledInputs.includes('inputRootCause') &&
      <div className="d-flex">
          <p className="label">Root Cause:</p><p className="data">{props.rootCause}</p>
      </div>
      }
      {props.enabledInputs.includes('inputEndState') &&
      <div className="d-flex">
          <p className="label">End State:</p><p className="data">{props.endState}</p>
      </div>
      }
      <div className="d-flex">
        <p className="label">Team:</p><p className="data">{props.avid}</p>
      </div>
    </div>
  );
};
